jQuery.fn.formSubmitOnce = function() {
    var $form = $(this);
    var isSubmitted = 'isSubmitted';
    $form.on('submit', function(event) {
        if ($form.data(isSubmitted) === true) {
            event.preventDefault();
            return;
        }

        $form.data(isSubmitted, true);
        $form.css('opacity', 0.5);
        $(':input', $form).prop('readonly', true);
        $('#absolute-center-spinner').removeClass('hide');
    });

    return this;
};

$('[data-form-submit-once]').formSubmitOnce();
